import { AppDispatch, Store } from 'store';
import getSearchFilters from 'store/search/selector/getSearchFilters';
import getSearchQuery from 'store/search/selector/getSearchQuery';
import getSearchSession from 'store/search/selector/getSearchSessionId';
import getSearchSortBy from 'store/search/selector/getSearchSortBy';
import getHash from 'utils/getHash';
import getSearchStateForHash from 'store/search/selector/getSearchStateForHash';
import { SearchResultProduct } from 'store/search/types';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmSearchProductClickEvent, { LIST_SEARCH_RESULTS_PAGE } from 'utils/gtm/gtmSearchProductClickEvent';
import { gtmSelectItemEvent } from 'utils/gtm/gtmProductClickEvent';

const gtmSendProductClickEventOperation =
  (product: SearchResultProduct, index: number) => async (dispatch: AppDispatch, getState: () => Store) => {
    const store = getState();
    const searchQuery = getSearchQuery(store);
    const searchFilters = getSearchFilters(store);
    const searchSessionId = getSearchSession(store);
    const searchSortBy = getSearchSortBy(store);
    const searchStateHash = await getHash(getSearchStateForHash(store));

    const searchExtraParams = {
      searchQuery,
      searchSessionId,
      searchFilters,
      searchSortBy,
      searchStateHash,
    };

    gtmSendEvent(gtmSearchProductClickEvent(product, index, searchExtraParams));
    gtmSendEvent(gtmSelectItemEvent(product, index, LIST_SEARCH_RESULTS_PAGE, searchExtraParams));
  };

export default gtmSendProductClickEventOperation;
